const UserAvatarTexts = {
  'components.userAvatar.userAvatarModal.title': 'Detalhes do usuário',
  /* Buttons */
  'components.userAvatar.sendMessageButton': 'Enviar mensagem',
};

export default {
  ...UserAvatarTexts,
};
